import { createContext, PropsWithChildren } from 'react';

interface PackContextState {
    packTitle?: string;
}

export const PackContext = createContext<string | undefined>(undefined);

// This provider is used to surface the packTitle to the useSendAmplitudeEvent hook and is not user facing. There's no need to translate the packTitle.
export function PackProvider({
    packTitle,
    children,
}: PropsWithChildren<PackContextState>) {
    return (
        <PackContext.Provider value={packTitle}>
            {children}
        </PackContext.Provider>
    );
}
